(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
let sel = document.getElementById("collection-sort");

sel.onchange = function(e){
let s = e.target;
let u = s.dataset.url;
window.location.href = `${u}?sort_by=${s.value}`;
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-banner"] && !window.DesignMode) return;
  try {
     

function toDataURL(src, callback, outputFormat) {
  var img = new Image();
  img.crossOrigin = 'Anonymous';
  img.onload = function() {
    var canvas = document.createElement('CANVAS');
    var ctx = canvas.getContext('2d');
    var dataURL;
    canvas.height = this.naturalHeight;
    canvas.width = this.naturalWidth;
    ctx.drawImage(this, 0, 0);
    dataURL = canvas.toDataURL(outputFormat);
    callback(dataURL);
  };
  img.src = src;
  if (img.complete || img.complete === undefined) {
    img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
    img.src = src;
  }
} 
 
let i = 4;

function getcolor() {
    let img = document.getElementById('collection-image');

    if (img !== null) {
        img.setAttribute('crossOrigin', '');
        let hasRun = true;
        toDataURL(
            img.src,
            function(dataUrl) {
                //console.log('RESULT:', dataUrl);
                img.src = dataUrl; 
                        
                var canvas = document.createElement('canvas');
                canvas.width = img.width;
                canvas.height = img.height;
                canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height);

                var pixelData = canvas.getContext('2d').getImageData(i, i, 1, 1).data;
                
                var imgwrap = document.getElementById('collection-image-wrap');
                let r = pixelData[0];
                let g = pixelData[1];
                let b = pixelData[2];
                let a = pixelData[3];
                if (r + g + b + a === 0) {
                    i = i + 1;
                    getcolor();
                } else {
                    imgwrap.style.backgroundColor = `rgba(${r},${g},${b},${a})`;
                    imgwrap.classList.remove('hide-image-banner');
                }
            }
        )
    } else {
        var imgwrap = document.getElementById('collection-image-wrap');
        imgwrap.style.backgroundColor = `rgb(222, 117, 42)`;
    }

}

window.addEventListener("load", getcolor);
  

  } catch(e) { console.error(e); }
})();
})();
